import useBackend from "../../hooks/use_backend";
import { SubTitle, Title } from "./typography";
import { Box, Grid, Tooltip } from "@mui/material";
import InfoSvg from "../../images/info.svg";
import * as React from "react";

export function GridMetric(props) {
  return (
    <Grid xs={props.xs ? props.xs : 6} item sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Metric {...props} />
    </Grid>
  );
}

export function Metric({ name, value, width = 100, info = null }) {
  return (
    <Center mx={2} py={0.5} width={width}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5, minWidth: 0 }}>
        <SubTitle
          color="text.primary"
          fontSize={12}
          noWrap
          sx={{ maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {name}
        </SubTitle>
        {info && (
          <Tooltip title={info}>
            <img width={15} src={InfoSvg} alt="Info button" />
          </Tooltip>
        )}
      </Box>

      <Title fontSize={16} textTransform="default" color="text.primary">
        {value}
      </Title>
    </Center>
  );
}
export function Center(props) {
  return (
    <Box {...props} justifyContent="center" alignItems="center" display="flex" flexDirection="column">
      {props.children}
    </Box>
  );
}

export function ColoredChip({ backgroundColor, children, fontSize }) {
  return (
    <span
      style={{
        color: "white",
        backgroundColor: backgroundColor,
        borderRadius: 20,
        padding: "5px 6px",
        fontSize: fontSize ? fontSize : 8,
        fontWeight: "bold",
        marginRight: 5,
      }}
    >
      {children}
    </span>
  );
}

export function AutoFetch({ fetchKey, fetch, frequency }) {
  const firstRender = React.useRef(true);
  const backend = useBackend();

  React.useEffect(() => {
    if (fetchKey === undefined || fetchKey === null) return;
    const interval = setInterval(() => fetch(backend), frequency);
    return () => clearInterval(interval);
  }, [fetchKey, frequency]);

  React.useEffect(() => {
    if (firstRender.current == true) {
      fetch(backend);
      firstRender.current = false;
    }
  }, []);

  React.useEffect(() => {
    fetch(backend);
  }, [fetchKey]);

  return null;
}
